import React, { useContext, useEffect, useState } from 'react';
import {
  Radio,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Select,
  MenuItem,
} from '@mui/material';
import smallTick from '../../../assets/UserProfile/green-small-tick.svg';
import smallTickClose from '../../../assets/UserProfile/red-close-small.svg';
import edit_circle_gray from '../../../assets/UserProfile/edit_circle_gray.svg';
import view_circle_gray from '../../../assets/UserProfile/view_circle_gray.svg';
import delete_ciircle_gray from '../../../assets/UserProfile/delete_ciircle_gray.svg';
import UserProfileModal from '../UserProfileModal';
import dotsimg from '../../../assets/UserProfile/userdetailsEllipse.svg';
import { Context } from '../../../services/apiContext';
import configData from '../../../utils/config/config.json';
import { useNotificationActionsContext } from '../../../components/notificationModal/useModal';
import { Link, Navigate } from 'react-router-dom';
import { Formerror } from '../../../components/formerror';
import { useGlobalSpinnerActionsContext } from '../../../components/loader/useloader';
import ClickAwayListener from '@mui/material/ClickAwayListener';

import {
  getClientIp,
  maskingFunction,
} from '../../../helperFunctions/helperFunctions';
import InfoLogo from '../../../components/Info';

const DematDetails = ({
  nextStep,
  dematData,
  handleInputDataDemat,
  handleValidity,
  profileData,
  isfromDashBoard,
  GotTOCreateDmata,
  isRedirected,
  isfromCSC,
}) => {
  const setNotifi = useNotificationActionsContext();
  const confirmationName = 'delete';

  const contextapi = useContext(Context);
  const checkifcleared = (e) => {
    console.log(e.keyCode);
    if (e.keyCode === 8) {
      handleInputDataDemat('dpId', '');
    }
  };
  const handleDematList = (e) => {
    const { name, value } = e.target;
    handleInputDataDemat(name, value);
    if (name === 'depositerName') {
      console.log(value);
      console.log(value.length);

      getDematByName(value);
    }
    setDematDetailsErrors({ ...dematDetailsErrors, name: '' });
  };

  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const checkErrors = async (data) => {
    const errorsForm = {};
    if (data.depositerName.trim() === '') {
      errorsForm.depositerName = 'Depositor name is required';
    }
    if (data.dpId.trim() === '') {
      errorsForm.dpId = 'DP ID is required';
    }

    if (data.clientid.trim() === '') {
      errorsForm.clientid = 'CLient ID is required';
    }
    if (
      data.clientid.trim() !== '' &&
      data.dematMode === 'NSDL' &&
      data.clientid.trim().length !== 8
    ) {
      errorsForm.clientid = 'CLient ID should be numeric and 8 digts';
    }
    if (
      data.clientid.trim() !== '' &&
      data.dematMode === 'CDSL' &&
      data.clientid.trim().length !== 16
    ) {
      errorsForm.clientid = 'CLient ID should be numeric and 16 digts';
    }
    return errorsForm;
  };
  const [dematDetailsErrors, setDematDetailsErrors] = useState({});
  const [redirecred, setRedirecred] = useState(false);

  const [demartSearch, setDemartSearch] = useState([]);
  const [availableDPIDs,setAvailableDPIDS] = useState([])
  const [showDPIDList,setShowDPIDList] = useState(false)

  const setDepostitorName = (selctedData) => {
    setAvailableDPIDS(selctedData.dpids?.map(d => d.dpid))
    handleInputDataDemat('dpId', selctedData.dpids[0].dpid);
    handleInputDataDemat('depositerName', selctedData.dpname);
    setDemartSearch([]);
  };
  const getDPById = async (DPID) => {
    var useData = contextapi.getSession('userData').user_key;
    var postData = {
      data: {
        user_key: useData,
        dpid: DPID,
        user_ip: await getClientIp(),
      },
      url: configData.baseURLDev + '/user/dpname',
    };
    var url = configData.baseURLProxy;
    await contextapi
      .postApiAuthCalling(url, postData, false)
      .then((res) => {
        console.log(res);
        if (res.msg === 'sucess') {
          var depositerName = res.data.dpname;
          handleInputDataDemat('depositerName', depositerName);
        }
      })
      .catch((error) => {
        console.log(error);
        // setNotifi({ val: true, msg: "Something went wrong" });
      });
  };
  const handleOnAddDP = async () => {
    setGlobalSpinner(true);
    const error = await checkErrors(dematData);
    if (Object.keys(error).length > 0) {
      await setDematDetailsErrors(error);
      setGlobalSpinner(false);
    } else {
      addDpDetails();
    }
  };
  useEffect(() => {
    console.log(dematData);
    var userProfile = contextapi.getSession('userProfile');
    if (
      dematData.dematList.length === 0 &&
      isfromDashBoard === false &&
      userProfile.basic_profile === 'Y'
    ) {
      getDepositorData();
    }
  }, []);
  const handleOnCreateDemat = () => {
    GotTOCreateDmata(4, false);
  };
  const handleOnCreateDemat2 = () => {
    GotTOCreateDmata(4, true);
  };
  const getDepositorData = async () => {
    var useData = contextapi.getSession('userData').user_key;
    var panToken = contextapi.getSession('userData').pan;
    console.log(panToken);
    var postData = {
      data: {
        user_key: useData,
        pan: profileData.pan === '' ? panToken : profileData.pan,
        user_ip: await getClientIp(),
      },
      url: configData.baseURLDev + '/user/repositorydata',
    };
    console.log(postData);
    var url = configData.baseURLProxy;
    await contextapi
      .postApiAuthCalling(url, postData, false)
      .then((res) => {
        console.log(res);
        if (res.msg === 'sucess') {
          if (res.data[0].dpclids !== null) {
            if (res.data[0].dpclids.length > 0) {
              var depositerName = res.data[0].dpclids;
              var depositerlist = [];

              depositerName.forEach((element) => {
                let newData = {};
                newData.dpid = element.dpid;
                newData.clientid = element.clientid;
                newData.depositerName = element.dp_name;
                newData.status = 'verified';
                newData.email = element.email;
                newData.mobile = element.mobile;
                newData.src = element.src;
                newData.isMasked = true;
                depositerlist.push(newData);
              });

              handleInputDataDemat('dematList', depositerlist);
              addDpFirstTimeDetails(depositerlist);
            }
          } else if (isRedirected === false) {
            handleOnCreateDemat2();
          }
        }
      })
      .catch((error) => {
        console.log(error);
        // setNotifi({ val: true, msg: "Something went wrong" });
      });
  };
  const [dematMode, setdematMode] = useState('NSDL');
  const getDematByName = async (searchKey) => {
    if (searchKey.length > 2) {
      var useData = contextapi.getSession('userData').user_key;
      var postData = {
        data: {
          user_key: useData,
          dpname: searchKey,
          user_ip: await getClientIp(),
          depository: dematData.dematMode === 'NSDL' ? 'N' : 'C',
        },
        url: configData.baseURLDev + '/user/dpsearch',
      };
      console.log(postData);
      var url = configData.baseURLProxy;
      await contextapi
        .postApiAuthCalling(url, postData, false)
        .then((res) => {
          console.log(res);
          if (res.msg === 'sucess') {
            var depositerlist =
              res.data[0].dpnames === null ? [] : res.data[0].dpnames;
            setDemartSearch(depositerlist);
          } else {
            setDemartSearch([]);
            handleInputDataDemat('dpId', '');
          }
        })
        .catch((error) => {
          setDemartSearch([]);
          handleInputDataDemat('dpId', '');
          console.log(error);
          // setNotifi({ val: true, msg: "Something went wrong" });
        });
    } else {
      setDemartSearch([]);
      handleInputDataDemat('dpId', '');
    }
  };
  const toggleTab = (that) => {
    // setdematMode(that);
    handleInputDataDemat('dematMode', that);
  };

  const [editstatus, seteditstatus] = useState({
    status: false,
    data: {},
    index: null,
  });
  const editDematDetails = (that, index) => {
    console.log(that);
    handleInputDataDemat('dpId', that.dpid);
    handleInputDataDemat('clientid', that.clientid);
    handleInputDataDemat('depositerName', that.depositerName);
    seteditstatus({ status: true, data: that, index: index });
  };

  const saveDmat = async () => {
    setGlobalSpinner(true);
    const error = await checkErrors(dematData);
    if (Object.keys(error).length > 0) {
      await setDematDetailsErrors(error);
      setGlobalSpinner(false);
    } else {
      var olddata2 = dematData.dematList;
      var url = '/userp/updateclientids';
      var useData = contextapi.getSession('userData').user_key;
      var postData = {
        user_key: useData,
        pan: profileData.pan,
        mobile: editstatus.data.mobile,
        user_ip: await getClientIp(),
        old_dpid: editstatus.data.dpid,
        old_clientid: editstatus.data.clientid,
        new_src: 'U',
        new_dpid: dematData.dpId,
        new_clientid: dematData.clientid,
        new_dpname: dematData.depositerName,
      };

      await contextapi
        .postApiAuthCalling(url, postData, true)
        .then((res) => {
          console.log(res);
          if (res[0].status_code === '00') {
            setNotifi({ val: true, msg: 'Demat Updated Successfully' });
            var olddata = dematData.dematList;

            let newData = {};
            newData.depositerName = dematData.depositerName;
            newData.dpid = dematData.dpId;
            newData.clientid = dematData.clientid;
            newData.status = 'non-verified';
            newData.isMasked = true;
            newData.email = editstatus.data.email;
            newData.mobile = editstatus.data.mobile;
            newData.src = editstatus.data.src;
            console.log(newData);
            olddata[editstatus.index] = newData;
            console.log(olddata);

            handleInputDataDemat('dematList', olddata);
            handleInputDataDemat('dpId', '');
            handleInputDataDemat('clientid', '');
            handleInputDataDemat('depositerName', '');
            seteditstatus({ status: false, data: {}, index: null });
          } else {
            setNotifi({ val: true, msg: 'Something went wrong' });
            handleInputDataDemat('dpId', '');
            handleInputDataDemat('clientid', '');
            handleInputDataDemat('depositerName', '');
            handleInputDataDemat('dematList', olddata2);
            seteditstatus({ status: false, data: {}, index: null });
          }
        })
        .catch((error) => {
          console.log('Error VerifyUser : ', error);
          // setNotifi({ val: true, msg: "Something went wrong" });
        });
    }
  };
  const togglEye = (e, i) => {
    var olddata = dematData.dematList;

    let newData = {};
    newData.depositerName = e.depositerName;
    newData.dpid = e.dpid;
    newData.clientid = e.clientid;
    newData.status = e.status;
    newData.isMasked = !e.isMasked;
    newData.email = e.email;
    newData.mobile = e.mobile;
    newData.src = e.src;
    olddata[i] = newData;
    console.log(olddata);
    handleInputDataDemat('dematList', olddata);
  };

  const cancelDemat = () => {
    handleInputDataDemat('dpId', '');
    handleInputDataDemat('clientid', '');
    handleInputDataDemat('depositerName', '');
    seteditstatus({ status: false, data: {}, index: null });
  };

  const [openstatus, setopenstatus] = useState({
    value: false,
    parameters: {},
    index: null,
  });
  const deleteDP = (e, index) => {
    setopenstatus({ value: true, parameters: e, index: index });
    setstep(2);
  };
  const closestatus = (e) => {
    console.log(e);
    var parameters = openstatus.parameters;
    var index = openstatus.index;
    console.log(parameters);
    if (e === 'yes') {
      deleteDEmat(parameters);
    }
    setopenstatus({ value: false, parameters: {}, index: null });
    setstep(1);
  };
  const nextToBank = () => {
    if (dematData.dematList.length > 0) {
      handleValidity('step2Valid');
      nextStep();
    } else {
      setNotifi({
        val: true,
        msg: 'Please add atleast one Demat Account to continue . You can also create one using create demat',
      });
    }
  };
  const deleteDEmat = async (parameters) => {
    var url = '/userp/deleteclientids';
    var useData = contextapi.getSession('userData').user_key;

    var postData = {
      user_key: useData,
      pan: profileData.pan,
      dpid: parameters.dpid,
      user_ip: await getClientIp(),
      clientid: parameters.clientid,
    };
    console.log(postData);
    await contextapi
      .postApiAuthCalling(url, postData, true)
      .then((res) => {
        console.log(res);
        if (res[0].status_code === '00') {
          let filteredlist = dematData.dematList.filter(
            (item) => item !== parameters
          );
          handleInputDataDemat('dematList', filteredlist);
          setNotifi({ val: true, msg: 'Demat Details deleted Successfully' });
        } else {
          setNotifi({ val: true, msg: 'Something went wrong' });
        }
      })
      .catch((error) => {
        console.log('Error VerifyUser : ', error);
        // setNotifi({ val: true, msg: "Something went wrong" });
      });
  };
  const addDpDetails = async () => {
    var url = '/userp/addclientids';
    var useData = contextapi.getSession('userData').user_key;
    var clids = [];

    // dematData.dematList.forEach((element) => {
    let newData = {};
    newData.dp_name =
      dematData.depositerName !== '' ? dematData.depositerName : 'null';
    newData.dpid = dematData.dpId;
    newData.clientid = dematData.clientid;
    newData.email = profileData.email;
    newData.mobile = profileData.mobile;
    newData.src = 'U';
    clids.push(newData);
    // });

    var postData = {
      user_key: useData,
      pan: profileData.pan,

      user_ip: await getClientIp(),

      clids: clids,
    };
    console.log(postData);
    await contextapi
      .postApiAuthCalling(url, postData, true)
      .then((res) => {
        console.log(res);
        if (res[0].status_code === '00') {
          setNotifi({ val: true, msg: 'Demat Added Successfully' });
          var olddata = dematData.dematList;
          let newData = {};
          newData.depositerName = dematData.depositerName;
          newData.dpid = dematData.dpId;
          newData.clientid = dematData.clientid;
          newData.status = 'non-verified';
          newData.isMasked = true;
          newData.email = profileData.email;
          newData.mobile = profileData.mobile;
          newData.src = 'U';
          olddata.unshift(newData);
          console.log(olddata);
          handleInputDataDemat('dematList', olddata);
          handleInputDataDemat('dpId', '');
          handleInputDataDemat('clientid', '');
          handleInputDataDemat('depositerName', '');
          setGlobalSpinner(false);
        } else {
          setNotifi({ val: true, msg: 'Something went wrong' });
        }
      })
      .catch((error) => {
        console.log('Error add DP details : ', error);
        // setNotifi({ val: true, msg: "Something went wrong" });
      });
  };
  const addDpFirstTimeDetails = async (depositerlist) => {
    var url = '/userp/addclientids';
    var useData = contextapi.getSession('userData').user_key;
    var clids = [];

    depositerlist.forEach((element) => {
      let newData = {};
      newData.dp_name =
        element.depositerName !== '' ? element.depositerName : 'null';
      newData.dpid = element.dpid;
      newData.clientid = element.clientid;
      newData.email = element.email ? element.email : profileData.email;
      newData.mobile = element.mobile ? element.mobile : profileData.mobile;
      newData.src = element.src;
      clids.push(newData);
    });

    var postData = {
      user_key: useData,
      pan: profileData.pan,

      user_ip: await getClientIp(),

      clids: clids,
    };
    console.log(postData);
    await contextapi
      .postApiAuthCalling(url, postData, true)
      .then((res) => {
        console.log(res);
        if (res[0].status_code === '00') {
          handleValidity('step2Valid');
          // nextStep();
        } else {
          setNotifi({ val: true, msg: 'Something went wrong' });
        }
      })
      .catch((error) => {
        console.log('Error VerifyUser : ', error);
        // setNotifi({ val: true, msg: "Something went wrong" });
      });
  };
  const [step, setstep] = useState(1);
  const renderDemat = () => {
    switch (step) {
      case 1:
        return (
          <div className='row'>
            {!isfromCSC && (
              <div className='col-lg-12 col-xs-12'>
                <ol className='customol'>
                  <li>
                    You can manually add demat account details if it is not
                    pre-populated and click on <b>Add Demat</b>.
                  </li>
                  <li>
                    You can open a Demat account with broker of your choice by
                    clicking on <b>Create Demat</b>.
                  </li>
                </ol>
                <div className='addmargindemat '>
                  <FormControl component='fieldset'>
                    <RadioGroup
                      className='radiowrapperSwitch'
                      row
                      aria-label='gender'
                      name='row-radio-buttons-group'
                      value={dematData.dematMode}
                    >
                      <FormControlLabel
                        className={
                          dematMode === 'NSDL'
                            ? 'RadiodivSwitch radioptionSwitch borderradio '
                            : 'RadiodivSwitch radioptionSwitch'
                        }
                        value='NSDL'
                        control={<Radio className='colorchange' />}
                        onChange={() => toggleTab('NSDL')}
                        label='NSDL'
                      />
                      <FormControlLabel
                        className={
                          dematMode === 'CDSL'
                            ? 'RadiodivSwitch radioptionSwitch borderradio '
                            : 'RadiodivSwitch radioptionSwitch'
                        }
                        value='CDSL'
                        control={<Radio className='colorchange' />}
                        onChange={() => toggleTab('CDSL')}
                        label='CDSL'
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
              </div>
            )}
            {!isfromCSC && (
              <div className='row addmargindemat'>
                <div className='col-lg-4 col-md-12 col-ms-12'>
                  <div className='form-floating emailonhover'>
                    <input
                      type='text'
                      className='form-control'
                      id='txtDepositerName'
                      placeholder='DP Name'
                      name='depositerName'
                      required
                      autoComplete='off'
                      value={dematData.depositerName}
                      onChange={handleDematList}
                      onKeyDown={checkifcleared}
                    />
                    {demartSearch.length > 0 && (
                      <div className='customDropdown2'>
                        {demartSearch.map((data, i) => (
                          <p onClick={() => setDepostitorName(data)}>
                            {data.dpname}
                          </p>
                        ))}
                      </div>
                    )}
                    <label htmlFor='txtDepositerName'> DP Name </label>
                    <Formerror error={dematDetailsErrors.depositerName} />

                    <div className='inforinemail'>
                      <InfoLogo />
                      <div className='innerInfo'>
                        <div className='inner_innerInfo'>
                          <p>
                            Select the broker with whom you have a Demat
                            account.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {dematData.dematMode === 'NSDL' && (
                  <div className='col-lg-4 col-md-12 col-ms-12'>
                    {/* <Select
                      placeholder='DI ID'
                      onChange={handleDematList}
                      variant={`outlined`}
                      label={`DP ID`}
                      value={dematData.dpId}
                      name='dpId'
                      style={{minWidth:'220px'}}
                    >
                        {availableDPIDs.map((dpid, i) => (
                            <MenuItem  value={dpid}
                              // className={`p-2 mb-2 font-weight-bold`}
                            >
                              {dpid}
                            </MenuItem>
                          ))}

                    </Select> */}

                    <ClickAwayListener
                      onClickAway={()=>setShowDPIDList(!true)}
                    >
                    <div className='form-floating position-relative' style={{position:'relative'}}
                        // onBlur={()=>setShowDPDRP(!true)}
                    >
                      <input
                        value={dematData.dpId}
                        onChange={handleDematList}
                        type='text'
                        className='form-control'
                        id='txtDPID'
                        placeholder='DP ID'
                        name='dpId'
                        // readOnly
                        // disabled
                        required
                        autoComplete='off'
                        onFocus={()=>setShowDPIDList(true)}

                      />
                      {showDPIDList && !!availableDPIDs.length && (
                        <div className='position-absolute bg-white border rounded'
                          style={{bottom:'0',left:'0',width:'100%',position:'absolute',transform:'translateY(95%)'}}
                        >
                          {availableDPIDs.map((dpid, i) => (
                            <p onClick={() => {
                              handleInputDataDemat('dpId', dpid)
                              setShowDPIDList(false)
                            }}
                              className={`p-2 px-3 my-1 `} style={{fontWeight:'500'}}
                            >
                              {dpid}
                            </p>
                          ))}
                        </div>
                      )}
                      <label htmlFor='txtDPID'>
                        DP ID<span className='txt-red'>*</span>{' '}
                      </label>
                      <Formerror error={dematDetailsErrors.dpId} />
                    </div>
                    </ClickAwayListener>

                  </div>
                )}

                <div className='col-lg-4 col-md-12 col-ms-12'>
                  <div className='form-floating '>
                    <input
                      type='text'
                      className='form-control'
                      id='txtClientID'
                      placeholder='Client ID'
                      name='clientid'
                      value={dematData.clientid}
                      onChange={handleDematList}
                      autoComplete='off'
                      maxLength={dematData.dematMode === 'NSDL' ? 8 : 16}
                      // onChange={handleDematList}
                      required
                    />
                    <label htmlFor='txtClientID'>
                      {dematData.dematMode === 'NSDL'
                        ? 'Client ID'
                        : 'DP Client ID'}
                      <span className='txt-red'>*</span>{' '}
                    </label>
                    <Formerror error={dematDetailsErrors.clientid} />
                  </div>
                </div>
              </div>
            )}

            <div className='col-12 text-end '>
              {!editstatus.status && (
                <>
                  {!isfromCSC && (
                    <div className='dematBtnHoverdiv dematBtnHoverdiv1'>
                      <button
                        type='button'
                        name='button'
                        className='btnInuse  btn-secondaryCustom addMargin dematBtnHover'
                        onClick={handleOnAddDP}
                      >
                        <span className='txt-red'> + </span> Add Demat
                      </button>

                      <div className='inforindemat'>
                        <div className='inner_innerInfoDematbtn'>
                          <p>To add details to the below list, click here</p>
                        </div>
                      </div>
                    </div>
                  )}
                  {/* 
                  <Link to={{ pathname: "/createDemat" }}> */}
                  <div className='dematBtnHoverdiv '>
                    <button
                      type='button'
                      name='button'
                      className='btnInuse  btn-secondaryCustom addMargin'
                      onClick={handleOnCreateDemat}
                    >
                      Create Demat
                    </button>

                    <div className='inforindemat'>
                      <div className='inner_innerInfoDematbtn'>
                        <p>
                          Want to open Demat account with a preferred broker,
                          click here
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* </Link> */}
                </>
              )}

              {editstatus.status && (
                <>
                  <button
                    type='button'
                    name='button'
                    className='btnInuse  btn-secondaryCustom addMargin'
                    onClick={cancelDemat}
                  >
                    Cancel
                  </button>

                  <button
                    type='button'
                    name='button'
                    className=' btnInuse btn-default ml-15  makewhitcolor addMargin'
                    onClick={saveDmat}
                  >
                    Save
                  </button>
                </>
              )}
            </div>

            {dematData.dematList.length > 0 && (
              <div className='col-lg-12 col-sm-12 addextramargin'>
                <div className='table-responsive hideformob'>
                  <table className='table mb-0'>
                    <thead>
                      <tr>
                        <th>Broker Name</th>
                        <th>DP ID</th>
                        <th>Client ID</th>
                        <th className='dematBrokerStatis'>Status</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {dematData.dematList.map((e, i) => (
                        <tr key={i}>
                          <td>{e.depositerName}</td>
                          <td>{maskingFunction(e.dpid, e.isMasked, 3)}</td>
                          <td>{maskingFunction(e.clientid, e.isMasked, 3)}</td>
                          <td className='alignCenter'>
                            {e.status === 'verified' ? (
                              <span className='tag-style'>
                                Verified
                                <img
                                  src={smallTick}
                                  alt=''
                                  title=''
                                  className='editimg'
                                />
                              </span>
                            ) : (
                              <span className='tag-style red-tag'>
                                Not Verified
                                <img
                                  src={smallTickClose}
                                  alt=''
                                  title=''
                                  className='editimg'
                                />
                              </span>
                            )}
                          </td>
                          <td className='alignRight'>
                            <img
                              src={view_circle_gray}
                              alt='action'
                              className='actionclass'
                              onClick={() => togglEye(e, i)}
                            />
                            {!isfromCSC && (
                              <img
                                src={edit_circle_gray}
                                alt='action'
                                className='actionclass'
                                onClick={() => editDematDetails(e, i)}
                              />
                            )}
                            {!isfromCSC && (
                              <img
                                src={delete_ciircle_gray}
                                alt='action'
                                className='actionclass'
                                onClick={() => deleteDP(e, i)}
                              />
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <div className='mobiletable'>
                  {dematData.dematList.map((e, i) => (
                    <div className='makeitborder' key={i}>
                      <div className='row '>
                        <div className='col-11'>
                          <div className='maekflex'>
                            <p className='labelTab'>Broker</p>
                            <p className='valuetab'>{e.depositerName}</p>
                          </div>
                          <div className='maekflex'>
                            <p className='labelTab'>DP ID</p>
                            <p className='valuetab'>
                              {maskingFunction(e.dpid, e.isMasked, 3)}
                            </p>
                          </div>
                          <div className='maekflex'>
                            <p className='labelTab'>Client ID</p>
                            <p className='valuetab'>
                              {maskingFunction(e.clientid, e.isMasked, 3)}
                            </p>
                          </div>

                          <div className='relativepo '>
                            <p className='mokeinabsolute'>
                              {e.status === 'verified' ? (
                                <span className='tag-style'>
                                  Verified
                                  <img
                                    src={smallTick}
                                    alt=''
                                    title=''
                                    className='editimg'
                                  />
                                </span>
                              ) : (
                                <span className='tag-style red-tag'>
                                  Not Verified
                                  <img
                                    src={smallTickClose}
                                    alt=''
                                    title=''
                                    className='editimg'
                                  />
                                </span>
                              )}
                            </p>
                          </div>
                        </div>

                        <div className='col-1 makitrela'>
                          <div></div>

                          <div className='makeitab'>
                            <div className='dropdown'>
                              <img
                                src={dotsimg}
                                alt='dotimg'
                                className='dotImage'
                              />
                              <div className='dropdown-content'>
                                <p onClick={() => togglEye(e, i)}>{`${
                                  e.isMasked ? 'Show' : 'Hide'
                                }`}</p>
                                {!isfromCSC && (
                                  <p onClick={() => editDematDetails(e, i)}>
                                    Edit
                                  </p>
                                )}
                                {!isfromCSC && (
                                  <p onClick={() => deleteDP(e, i)}>Delete</p>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div className='col-lg-12 col-sm-12 textCenter'>
              <button
                type='button'
                name='button'
                className='makewhitcolor btnInuse btn-default'
                onClick={nextToBank}
              >
                {' '}
                Save and Continue{' '}
              </button>
            </div>
            <div className='col-lg-12 col-sm-12 text-right addmargintop'>
              <p>*In CDSL, Client ID is inclusive of DP ID</p>
            </div>
          </div>
        );
      case 2:
        return (
          <div className='minheigh'>
            <UserProfileModal
              openstatus={openstatus.value}
              closestatus={closestatus}
              confirmationName={confirmationName}
              TitleName=''
              dematLinksandName=''
            />
          </div>
        );
    }
  };

  return <>{renderDemat()}</>;
};

export default DematDetails;
